import types from "./types";
import { combineReducers } from "redux";
import {
  validateEmail,
  invValidation,
  registerUser,
  validateToken,
} from "../api/registration";
import { CALL_API } from "@cdkglobal/react-core-reduxapi";

const validateEmailStatus = (
  validateEmailStatus = {
    isLoading: false,
    error: false,
    valid: false,
    code: 0,
    role: false,
  },
  action
) => {
  switch (action.type) {
    case types.REGISTRATION_VALIDATE_EMAIL_REQUEST:
      return { isLoading: true, error: false, vaild: false, code: 0 };
    case types.REGISTRATION_VALIDATE_EMAIL_RECEIVE:
      let valid = false;
      let error = false;
      let code = 0;
      if (action.response && "valid" in action.response) {
        valid = action.response.valid;
      }

      if (action.response && "code" in action.response) {
        code = action.response.code;
      }

      if (code === 3) {
        error =
          "Your email address is not one of our supported domains, please make sure you are using your work email address and not your personal.";
      }

      return {
        isLoading: false,
        valid: valid,
        code: code,
        error: error,
      };
    case types.REGISTRATION_VALIDATE_EMAIL_ERROR:
      code = 0;
      let role = null;
      error =
        "Unable to validate email at this time, please try again later. If the problem persists please email our support team at cdkhub.admin@cdk.com. If you have questions or need further assistance please contact 866.510.5103";
      if (action.apierror.payload && "code" in action.apierror.payload) {
        code = action.apierror.payload.code;
      }

      if (code === 2) {
        error = false;
        role = action.apierror.payload.role;
      }

      return {
        isLoading: false,
        error: error,
        valid: false,
        code: code,
        role: role,
      };
    case types.REGISTRATION_VALIDATE_EMAIL_CLEAR_ERROR:
      return { ...validateEmailStatus, error: false };
    default:
      return validateEmailStatus;
  }
};

const validationTokenResponse = (validationTokenResp = null, action) => {
  switch (action.type) {
    case types.REGISTRATION_VALIDATE_TOKEN_RECEIVE:
      return action.response;
    default:
      return validationTokenResp;
  }
};

const invValidationResponse = (invValidationResp = null, action) => {
  switch (action.type) {
    case types.REGISTRATION_VALIDATE_CMF_RECEIVE:
      return action.response;
    default:
      return invValidationResp;
  }
};

const registerUserResponse = (registerUserResp = null, action) => {
  switch (action.type) {
    case types.REGISTRATION_REGISTERUSER_RECEIVE:
      return action.response;
    default:
      return registerUserResp;
  }
};

const selfRegistrationStatus = (
  selfRegistrationStatus = {
    isLoading: true,
    error: "",
  },
  action
) => {
  let error;
  let code = 0;
  switch (action.type) {
    case types.REGISTRATION_VALIDATE_TOKEN_REQUEST:
      return { isLoading: true, error: "" };
    case types.REGISTRATION_VALIDATE_TOKEN_RECEIVE:
      return { isLoading: false, error: "" };
    case types.REGISTRATION_VALIDATE_TOKEN_ERROR:
      error =
        "Unable to validate token at this time, please try again later. If the problem persists please email our support team at cdkhub.admin@cdk.com. If you have questions or need further assistance please contact 866.510.5103";
      if (action.apierror.response && action.apierror.response.status === 400) {
        error =
          "Invalid token, this token may have already been used or succeeded by a newer token.";
      }
      if (action.apierror.response && action.apierror.response.status === 409) {
        error =
          "We're really sorry but it looks like an error was encountered when trying to register you to the CDK Hub. To finish your registration please email our support team at cdkhub.admin@cdk.com or call 866.510.5103";
      }
      return {
        isLoading: false,
        error: error,
      };

    case types.REGISTRATION_VALIDATE_CMF_REQUEST:
      return { isLoading: true, error: "" };
    case types.REGISTRATION_VALIDATE_CMF_RECEIVE:
      return { isLoading: false, error: "" };
    case types.REGISTRATION_VALIDATE_CMF_ERROR:
      error =
        "Unable to validate invoice information at this time, please try again later. If the problem persists please email our support team at cdkhub.admin@cdk.com. If you have questions or need further assistance please contact 866.510.5103";
      if (action.apierror.response && action.apierror.response.status === 400) {
        if (action.apierror.payload.reason === "CMF not migrated") {
          error =
            "Unfortunately your customer account has not yet been mirgated to CDK Hub. We plan to have all our customer migrated by July 2020, thank you for your patience.";
        } else {
          error =
            "The Invoice details or Customer number entered doesn't match our records, make sure you are using your most recent invoice.";
        }
      }
      return {
        isLoading: false,
        error: error,
      };

    case types.REGISTRATION_REGISTERUSER_REQUEST:
      return { isLoading: true, error: "" };
    case types.REGISTRATION_REGISTERUSER_RECEIVE:
      return { isLoading: false, error: "" };
    case types.REGISTRATION_REGISTERUSER_ERROR:
      error = "Unable to complete registration, please try again later.";
      code = 1;
      if (
        action.apierror.payload &&
        "connectCDKStatus" in action.apierror.payload &&
        action.apierror.payload.connectCDKStatus === false
      ) {
        error =
          "Unable to complete registration, failed to create user in Connect CDK.";
      }
      return {
        isLoading: false,
        error: error,
        code: code,
      };

    default:
      return selfRegistrationStatus;
  }
};

export default combineReducers({
  validateEmailStatus,
  selfRegistrationStatus,
  validationTokenResponse,
  invValidationResponse,
  registerUserResponse,
});

export const actions = {
  validateEmail: (params, domain) => ({
    [CALL_API]: {
      ...validateEmail(params, domain),
      types: [
        types.REGISTRATION_VALIDATE_EMAIL_REQUEST,
        types.REGISTRATION_VALIDATE_EMAIL_RECEIVE,
        types.REGISTRATION_VALIDATE_EMAIL_ERROR,
      ],
    },
  }),
  clearValidateEmailError: () => ({
    type: types.REGISTRATION_VALIDATE_EMAIL_CLEAR_ERROR,
  }),
  clearValidateEmail: () => ({ type: types.REGISTRATION_VALIDATE_EMAIL_CLEAR }),

  validateToken: (params) => ({
    [CALL_API]: {
      ...validateToken(params),
      types: [
        types.REGISTRATION_VALIDATE_TOKEN_REQUEST,
        types.REGISTRATION_VALIDATE_TOKEN_RECEIVE,
        types.REGISTRATION_VALIDATE_TOKEN_ERROR,
      ],
    },
  }),

  invValidation: (params) => ({
    [CALL_API]: {
      ...invValidation(params),
      types: [
        types.REGISTRATION_VALIDATE_CMF_REQUEST,
        types.REGISTRATION_VALIDATE_CMF_RECEIVE,
        types.REGISTRATION_VALIDATE_CMF_ERROR,
      ],
    },
  }),

  registerUser: (data) => ({
    [CALL_API]: {
      ...registerUser(data),
      types: [
        types.REGISTRATION_REGISTERUSER_REQUEST,
        types.REGISTRATION_REGISTERUSER_RECEIVE,
        types.REGISTRATION_REGISTERUSER_ERROR,
      ],
    },
  }),
};
